import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { userDTO } from "../../types/types";

type LoginCredentialsDTO = {
    username: string;
    password: string;
};

type LoginResponse = {
    role:string;
    user: userDTO;
    access_token: string;
} & ApiError;

export const login = (data: LoginCredentialsDTO): Promise<LoginResponse> => {
    return axios.post("/auth/user/login", data)
        .then(response => response.data as LoginResponse);
};
export const adminLogin = (data: LoginCredentialsDTO): Promise<LoginResponse> => {
    return axios.post("/auth/admin/login", data)
        .then(response => response.data as LoginResponse);
};
export const salesLogin = (data: LoginCredentialsDTO): Promise<LoginResponse> => {
    return axios.post("/auth/sales/login", data)
        .then(response => response.data as LoginResponse);
};